import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiConfiguration } from "../api/api-configuration";
import { GlobalApp } from "./global";

@Injectable()
export class AppInitService {
  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfiguration,
    private globalApp: GlobalApp
  ) {}

  async Init() {
    return new Promise<void>((resolve, reject) => {
      this.http.get<string>("api/Config/GetApiUrl").subscribe((result) => {
        this.apiConfig.rootUrl = result.substr(0, result.length - 1);
        resolve();
      });
    });
  }
}
